//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AppContainer from 'app_components/layouts/app'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../officialsLandingScreen.scss'
import OfficialslandingModule from 'app_components/modules/admin/landings/officialslanding'
import BreadcrumbComponent from 'app_components/commons/breadcrumb';

// @ADD Component types
interface IOfficialsLandingScreenLayoutProps {}

const OfficialsLandingScreenLayout: React.FC<IOfficialsLandingScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <AppContainer>
      <div className='officials_landung_screen-layout'>
        <BreadcrumbComponent
          links={['/admin/landings', '#']}
          texts={[`${t('components.breadcrumb.landings')}`, `${t('components.breadcrumb.officials_landing')}`]}
        />
        <div className="row">
          <div className="col-6">
            <OfficialslandingModule/>
          </div>
        </div>
      </div>
    </AppContainer>
  )
}

export default OfficialsLandingScreenLayout
